export default __webpack_public_path__ + "static/media/Sliders-Home-02-1.59b31477.webp";